import { PatientInfo } from "./details/program-details";
import { PatientLogTabs } from "./tab/tabs";
import { Patient } from "../api/types";
import { useQuery } from "@tanstack/react-query";
import { patientDetailsQueryOptions } from "../api/queries";
import { getRouteApi } from "@tanstack/react-router";
import { UrgentCarePatientLogTabs } from "./tab/urgent-tabs";
import { PatientStatus } from "./card/patient-card/patient-status";
import { Image } from "@workspace/web-ui/components/image";

interface PatientDetailsProps {
    patient: Patient;
}

const PatientDetails = ({ patient }: PatientDetailsProps) => {
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
    const { program } = routeApi.useParams();

    useQuery(patientDetailsQueryOptions(patient?.userId ?? "", program ?? ""))
    return (
        <div className="flex flex-col gap-4 border border-[#04040433] bg-white rounded-[24px] py-6 px-4">
            <div className="flex flex-col gap-4">
                <div className="flex gap-4 items-center">
                    <div className="flex gap-2 items-center">
                        <h1 className="text-[32px] font-semibold">{patient?.name}</h1>
                        {program === "urgent-care" ? (
                            patient.urgent_care_onboarded && patient.identity_verified && (
                                <div className="">
                                    <Image src="/icons/check.svg" alt="timeline" layout="constrained" className="w-4 h-4 sm:w-5 sm:h-5" width={96} height={96} />
                                </div>
                            )
                        ) : (
                            patient.medicalPlan?.payment_status === "paid" && patient.glp1_guide_accepted && patient.identity_verified && patient.supplementary_health_assessment && Object.keys(patient.supplementary_health_assessment).length > 0 && (
                                <div className="">
                                    <Image src="/icons/check.svg" alt="timeline" layout="constrained" className="w-4 h-4 sm:w-5 sm:h-5" width={96} height={96} />
                                </div>
                            )
                        )}
                    </div>
                    {program === "urgent-care" ? (
                        patient?.patient_sessions_state === "all_sessions_ended" ? (
                            <PatientStatus status={"Closed"} />
                        ) :
                            patient?.patient_sessions_state === "pending_review" ? (
                                <PatientStatus status={"Pending Review"} />
                            ) :
                                patient?.patient_sessions_state === "in_progress" ? (
                                    <PatientStatus status={"In Progress"} />
                                ) : null
                    ) : (
                        patient?.medicalPlan?.payment_status === "paid" ? (
                            <PatientStatus status={"Paid"} />
                        ) : (
                            <PatientStatus status={"Not Paid"} />
                        )
                    )}
                </div>
                <PatientInfo patient={patient} program={program ?? ""} />

            </div>
            <div className="flex flex-col gap-4 mt-5">
                {program === "urgent-care" ? (
                    <UrgentCarePatientLogTabs userId={patient?.userId ?? ""} sessionId={patient.consultation?.session_id ?? ""} />
                ) : (
                    <PatientLogTabs userId={patient?.userId ?? ""} program={program} />
                )}
            </div>
        </div>
    )
}

export default PatientDetails;